import { FunctionalComponent, h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { useForm } from "react-hook-form";
import { PrimaryButton } from "../../components/button/primary";
import { SecondaryButton } from "../../components/button/secondary";
import Container from "../../components/container";
import BaseForm from "../../components/form";
import { TextHeader } from "../../components/text";
import { COULMN_DATA } from "./constants/columns";
import { FORM_SEARCH } from "./constants/forms";
import {
  ContainerDataRepair,
  ContainerSearch,
  DivButtonExportFile,
} from "./styled";
import { TableData } from "./view/table/data";
import { Divider } from "antd";
import { useGet } from "./hook/useGet";
import qurrystring from "query-string";
import { convertDateTime, convertStrRepair } from "../../functions";
import { IStateChangeMain } from "./interface/statemaintenances";
import { IModalRef } from "./interface/modal";
import { ModalEditData } from "./view/modal/edit-data";
import { ModalConfirmGetJob } from "./view/modal/confirm-get-job";
import { ModalEndJobTech } from "./view/modal/end-job-tech";
import { ModalEndJob } from "./view/modal/end-job";
import { findStatus } from "./functions";
import { ModalConfirmTechGetJob } from "./view/modal/confirm-tech-get-job";
import { ModalDeleteRepair } from "./view/modal/delete-repair";
import { useDelete } from "./hook/useDelete";
import WrapperComponent from "../../components/hoc/WrapperComponent";
import { HEADERS } from "./constants/exportexcel";
import { ButtonCSV } from "../../components/button/buttonCSV";
import _ from "lodash";
import { useMessage } from "../../hooks/useMessage";
import { POST, POST_EXPORT_SPARE } from "../../services";

const RepairScene: FunctionalComponent = () => {
  let modalRefEditData = useRef<IModalRef>();
  let modalRefComfirmGetjob = useRef<IModalRef>();
  let modalRefTechEndJob = useRef<IModalRef>();
  let modalRefEndJob = useRef<IModalRef>();
  let modalRefDelete = useRef<IModalRef>();
  const [forceLoading, setForceLoading] = useState(false);
  const [forceLoadingSearch, setForceLoadingSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit, watch } = useForm(
    {}
  );
  const { openMessage } = useMessage();

  const { search_repairstartdate: startDate, search_repairenddate: endDate } =
    watch();

  const {
    useGetMaintainDeviceStatusOption,
    options,
    useGetMaintenances,
    onSearch,
    stateMaintenances,
    setStateMaintenances,
  } = useGet();

  const { onDelete } = useDelete();

  useEffect(() => {
    useGetMaintainDeviceStatusOption();
  }, []);

  useEffect(() => {
    const firstGetMaintenances = async () => {
      try {
        setLoading(true);
        await useGetMaintenances();
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    firstGetMaintenances();
  }, []);

  const onSubmitSearch = async () => {
    const {
      search_id,
      search_name_customerid,
      search_repairenddate,
      search_repairstartdate,
      search_status_device,
    } = getValues();
    const params = {
      deviceId: search_id,
      customerCode: search_name_customerid,
      startDate:
        search_repairstartdate && convertDateTime(search_repairstartdate),
      endDate: search_repairenddate && convertDateTime(search_repairenddate),
      maintainStatus: search_status_device,
    };
    const queryString = qurrystring.stringify(params);
    setForceLoadingSearch(true);
    setLoading(true);
    window.history.replaceState(null, "", `?${queryString}`);
    await onSearch(queryString);
    setLoading(false);
    setForceLoadingSearch(false);
  };

  const onSubmitClearSearch = async (force?: boolean) => {
    reset();
    const deviceId = getValues().search_id;
    const lotId = getValues().search_pl;
    const status = getValues().search_status_device;
    const params = {
      deviceId: deviceId,
      lotId: lotId,
      status: status,
    };
    const queryString = qurrystring.stringify(params);
    force && setForceLoading(true);
    setLoading(true);
    window.history.replaceState(null, "", `?${queryString}`);
    await useGetMaintenances();
    setLoading(false);
    force && setForceLoading(false);
  };

  function onOpenModal(item: IStateChangeMain) {
    const { maintainStatusId } = item;
    switch (maintainStatusId) {
      case "STPH-002":
      case "STPH-003":
      case "STPH-004":
        modalRefComfirmGetjob.current &&
          modalRefComfirmGetjob.current.openModal(item);
        break;
      case "STPH-006":
        modalRefTechEndJob.current &&
          modalRefTechEndJob.current.openModal(item);
        break;
      case "STPH-007":
        modalRefEndJob.current && modalRefEndJob.current.openModal(item);
        break;
      default:
    }
  }

  function onCallbackEdit(item: IStateChangeMain) {
    const findIndex = stateMaintenances.findIndex(
      (e) => e.maintainId === item.maintainId
    );
    if (findIndex === -1) {
      return;
    }
    const maintenance = JSON.parse(JSON.stringify(stateMaintenances));
    const { maintainStatusId } = maintenance[findIndex];
    switch (maintainStatusId) {
      case "STPH-002":
      case "STPH-003":
      case "STPH-004":
        const { id, label } = findStatus("STPH-006", options);
        maintenance[findIndex].maintainStatusId = id;
        maintenance[findIndex].maintainStatus = label;
        break;
      case "STPH-006":
        const { id: id4, label: label4 } = findStatus("STPH-007", options);
        maintenance[findIndex].maintainStatusId = id4;
        maintenance[findIndex].maintainStatus = label4;
        if (item.main_endjob_deviceId) {
          maintenance[findIndex].deviceId = item.main_endjob_deviceId;
        }
        break;
      case "STPH-007":
        const { id: id5, label: label5 } = findStatus("STPH-100", options);
        maintenance[findIndex].maintainStatusId = id5;
        maintenance[findIndex].maintainStatus = label5;
        break;
      default:
        break;
    }
    setStateMaintenances(maintenance);
  }

  function onCallbackModalEdit(item: IStateChangeMain) {
    const findIndex = stateMaintenances.findIndex(
      (e) => e.maintainId === item.maintainId
    );
    if (findIndex === -1) {
      return;
    }
    const maintenance = JSON.parse(JSON.stringify(stateMaintenances));
    const { maintainStatusId, deviceId, customerName, customerCode } = item;
    const { id, label } = findStatus(maintainStatusId, options);
    maintenance[findIndex].maintainStatusId = id;
    maintenance[findIndex].maintainStatus = label;
    maintenance[findIndex].deviceId = deviceId;
    maintenance[findIndex].customerName = customerName;
    maintenance[findIndex].customerCode = customerCode;
    setStateMaintenances(maintenance);
  }

  const onCallbackDelete = async (item: IStateChangeMain, remark = "") => {
    const findIndex = stateMaintenances.findIndex(
      (e) => e.maintainId === item.maintainId
    );
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(
      JSON.stringify(stateMaintenances)
    ) as IStateChangeMain[];
    const { maintainId } = d[findIndex];
    const r = await onDelete(`${maintainId}`, remark);
    if (!r) {
      return;
    }
    d.splice(findIndex, 1);
    setStateMaintenances(d.map((e, i) => ({ ...e, index: i + 1 })));
  };

  const compairData = stateMaintenances.map((e: any) => ({
    ...e,
    maintainType: convertStrRepair(e.maintainType),
  }));

  const handleExportSpare = async () => {
    if (_.isEmpty(startDate) || _.isEmpty(endDate)) {
      return openMessage("error", "กรุณากรอกวันที่แจ้งซ่อมและวันที่สิ้นสุด");
    }
    setLoading(true);
    try {
      const payload = {
        startDate: convertDateTime(startDate),
        endDate: convertDateTime(endDate),
      };

      const res = await POST(POST_EXPORT_SPARE, payload);
      if (!res.success) {
        return;
      }
      openMessage("success", res.message);
      if (res.result?.downloadUrl) {
        window.open(res.result?.downloadUrl);
      }
    } catch (error) {
      openMessage("error", (error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <TextHeader text={"ซ่อม / เคลม"} divider={true} />
      <ContainerDataRepair>
        <BaseForm
          control={control}
          forms={FORM_SEARCH({ options, onSubmitSearch })}
          setValue={setValue}
          getValues={getValues}
        />
        <ContainerSearch>
          <PrimaryButton
            label={"ค้นหา"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ marginTop: "10px" }}
            tabletStyle={{ marginTop: "10px" }}
            isLoading={forceLoadingSearch}
            forceLoading={forceLoadingSearch}
            onPress={handleSubmit(onSubmitSearch)}
          />
          <SecondaryButton
            label={"ล้างข้อมูล"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ marginTop: "10px" }}
            tabletStyle={{ marginTop: "10px" }}
            isLoading={true}
            forceLoading={forceLoading}
            onPress={onSubmitClearSearch}
          />
        </ContainerSearch>
      </ContainerDataRepair>
      <Divider />
      <DivButtonExportFile style={{ gap: "1rem" }}>
        <PrimaryButton label="Export อะไหล่" onPress={handleExportSpare} />
        <ButtonCSV
          label={"Export"}
          data={compairData}
          header={HEADERS}
          style={{ marginLeft: "10px" }}
          mobileStyle={{ margin: "5px" }}
          tabletStyle={{ margin: "5px" }}
          fileName={"Exportrepair/claim.csv"}
        />
      </DivButtonExportFile>
      <TableData
        columns={COULMN_DATA({
          onEdit: (e: IStateChangeMain) =>
            modalRefEditData.current && modalRefEditData.current.openModal(e),
          onOpenModal: (e: IStateChangeMain) => onOpenModal(e),
          onDelete: (e: IStateChangeMain) =>
            modalRefDelete.current && modalRefDelete.current.openModal(e),
        })}
        data={stateMaintenances}
        loading={loading}
      />
      <ModalEditData
        ref={modalRefEditData}
        onCallbackEdit={(e: IStateChangeMain) => onCallbackModalEdit(e)}
        onOpenModal={(e: IStateChangeMain) => onOpenModal(e)}
        options={options}
      />
      <ModalConfirmGetJob
        ref={modalRefComfirmGetjob}
        onCallbackEdit={(e: IStateChangeMain) => onCallbackEdit(e)}
      />
      <ModalEndJobTech
        ref={modalRefTechEndJob}
        onCallbackEdit={(e: IStateChangeMain) => onCallbackEdit(e)}
      />
      <ModalEndJob
        ref={modalRefEndJob}
        onCallbackEdit={(e: IStateChangeMain) => onCallbackEdit(e)}
      />
      <ModalDeleteRepair
        ref={modalRefDelete}
        onCallbackDelete={(e: IStateChangeMain, remark: string) =>
          onCallbackDelete(e, remark)
        }
      />
    </Container>
  );
};

export default WrapperComponent("RepairScene")(RepairScene);
